(function () {
  /** @type {Set<HTMLDialogElement>} */
  var scrollLockDialogs = new Set();

  function syncScrollLock() {
    if (scrollLockDialogs.size > 0) {
      document.documentElement.setAttribute('scroll-lock', '');
    } else {
      document.documentElement.removeAttribute('scroll-lock');
    }
  }

  /** @param {HTMLDialogElement} dialog */
  function lockScroll(dialog) {
    scrollLockDialogs.add(dialog);
    syncScrollLock();
  }

  /** @param {HTMLDialogElement} dialog */
  function unlockScroll(dialog) {
    scrollLockDialogs.delete(dialog);
    syncScrollLock();
  }

  function closeModal(root) {
    var dialog = root.querySelector('[data-wbs-press-modal]');
    if (!dialog || !dialog.open) return;
    var iframe = root.querySelector('[data-wbs-press-iframe]');
    var external = root.querySelector('[data-wbs-press-external]');
    if (iframe) iframe.removeAttribute('src');
    if (external) external.setAttribute('href', '#');
    unlockScroll(dialog);
    dialog.close();
  }

  /** @param {HTMLElement} root @param {string} url @param {string} title */
  function openModal(root, url, title) {
    var dialog = root.querySelector('[data-wbs-press-modal]');
    if (!dialog || typeof dialog.showModal !== 'function' || !url) return;
    var iframe = root.querySelector('[data-wbs-press-iframe]');
    var titleEl = root.querySelector('[data-wbs-press-modal-title]');
    if (titleEl) titleEl.textContent = title || '';
    if (iframe) {
      iframe.title = title || 'Article';
      iframe.src = url;
    }
    var external = root.querySelector('[data-wbs-press-external]');
    if (external) external.setAttribute('href', url);
    dialog.showModal();
    lockScroll(dialog);
  }

  function init(root) {
    if (root.dataset.wbsPressReady === 'true') return;
    root.dataset.wbsPressReady = 'true';

    root.querySelectorAll('[data-wbs-open-press]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var url = trigger.getAttribute('data-wbs-article-url') || '';
        var title = trigger.getAttribute('data-wbs-article-title') || '';
        if (!url) return;
        openModal(root, url, title);
      });
    });

    var dialog = root.querySelector('[data-wbs-press-modal]');
    if (!dialog) return;

    root.querySelectorAll('[data-wbs-close-press]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(root);
      });
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal(root);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeModal(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-wbs-press]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wbs-press]');
    if (!root && event.target.matches && event.target.matches('[data-wbs-press]')) {
      root = event.target;
    }
    if (root) init(root);
  });
})();
